//Ao abrir a tela, passar um ?empresa_cnpj=15115563000100 como parametro GET na URL.

//React
import React, { useEffect, useState, useContext } from "react";

//Material
import {
  Grid,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Tooltip,
} from "@material-ui/core";

import { Search, ExpandMore } from "@material-ui/icons";
import { findLocaisEstoques } from "../../../../repositories/qerpapi/erp/estoque/v1/LocalEstoqueRepository";
import SelectErp from "../../../../components/basics/SelectErp";
import Chip from "../../../../components/basics/Chip";
import TextFieldErp from "../../../../components/basics/TextFieldErp";

//OurComponents
import { PrescricaoContext } from "../contexts/PrescricaoContext";
import { HeaderAccordion, IconButtonStyled } from "../styles/Prescricao";

/* 
  A estilização é feita via Styled Components, uma biblioteca CSS in JS. 
  Com essa lib pode-se criar uma estilização diânimica e hierarquizada.
  É valido dar uma olhada na documentação: https://styled-components.com/;
  Baixar extensão styled components no VsCode.
*/
//Styles

//Controller (functions)
import usePrescricaoController from "../controllers/PrescricaoController";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import SearchDialog from "../../../../patterns/modals/SearchDialog";

const AccordionPrescricaoProduto = ({ ...props }) => {
  //Variaveis que serão utilizadas, vindas do 'Controller'
  const { queryParams } = useContext(QueryParamsContext);
  const {
    expanded,
    localFilter,
    setLocalFilter,
    produtoLenteCodigo,
    setProdutoLenteCodigo,
    produtoLenteDescricaoSelected,
    setProdutoLenteDescricaoSelected,
    produtoAroCodigo,
    setProdutoAroCodigo,
    produtoAroDescricaoSelected,
    setProdutoAroDescricaoSelected,
  } = useContext(PrescricaoContext);

  const { handleChangeOpenAcordion } = usePrescricaoController();

  const [localTable, setLocalTable] = useState([]);
  const [lenteTable, setLenteTable] = useState([]);
  const [aroTable, setAroTable] = useState([]);
  const [localLoading, setLocalLoading] = useState(false);
  const [searchLenteOpen, setSearchLenteOpen] = useState(false);
  const [searchAroOpen, setSearchAroOpen] = useState(false);

  const columns = [
    {
      id: "descricao",
      label: "Descrição",
    },
    {
      id: "codigobarras",
      label: "Codigo de Barras",
    },
  ];

  useEffect(() => {
    (async () => {
      try {
        setLocalLoading(true);
        const resultLocal = await findLocaisEstoques(
          queryParams?.empresa_cnpj || ""
        );
        if (resultLocal.success)
          setLocalTable(resultLocal.data.filter((el) => el.ativo !== "N"));
      } catch (error) {
      } finally {
        setLocalLoading(false);
      }
    })();
  }, [queryParams]);

  const handleSelectLenteProduto = (setSearchLenteOpen, selectedProduto) => {
    setSearchLenteOpen(false);
    setProdutoLenteCodigo(selectedProduto[0].codigobarras || 0);
    setLenteTable(selectedProduto);
    setProdutoLenteDescricaoSelected(selectedProduto[0]);
  };

  const handleSelectAroProduto = (setSearchAroOpen, selectedProduto) => {
    setSearchAroOpen(false);
    setProdutoAroCodigo(selectedProduto[0].codigobarras || 0);
    setAroTable(selectedProduto);
    setProdutoAroDescricaoSelected(selectedProduto[0]);
  };

  // View
  return (
    <>
      {searchLenteOpen && (
        <SearchDialog
          open={searchLenteOpen}
          setOpen={setSearchLenteOpen}
          columns={columns}
          selectable={true}
          multiSelect={false}
          handleMainClick={handleSelectLenteProduto}
          route="estoque/produtos/v1/porlocalestoquefilter"
          title="PRODUTOS LENTE"
          rawUrl={`${
            localFilter?.id ? `&stockLocation=${localFilter?.id}` : ""
          }${produtoLenteCodigo ? `&codeBar=${produtoLenteCodigo}` : ""}${
            produtoLenteDescricaoSelected?.descricao
              ? `&description=${produtoLenteDescricaoSelected?.descricao}`
              : ""
          }`}
        />
      )}
      {searchAroOpen && (
        <SearchDialog
          open={searchAroOpen}
          setOpen={setSearchAroOpen}
          columns={columns}
          selectable={true}
          multiSelect={false}
          handleMainClick={handleSelectAroProduto}
          route="estoque/produtos/v1/porlocalestoquefilter"
          title="PRODUTOS ARO"
          rawUrl={`${
            localFilter?.id ? `&stockLocation=${localFilter?.id}` : ""
          }${produtoAroCodigo ? `&codeBar=${produtoAroCodigo}` : ""}${
            produtoAroDescricaoSelected?.descricao
              ? `&description=${produtoAroDescricaoSelected?.descricao}`
              : ""
          }`}
        />
      )}
      <Grid item xs={12}>
        <Accordion
          expanded={expanded?.produto || false}
          onChange={() => handleChangeOpenAcordion("produto")}
        >
          <AccordionSummary
            expandIcon={<ExpandMore />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <HeaderAccordion>
              <Grid container>
                <Grid item xs={12}>
                  <Chip bgcolor={"default"} label="PRODUTO" />
                </Grid>
              </Grid>
            </HeaderAccordion>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid item xs={2}>
                <SelectErp
                  id="estoque"
                  label="Local de Estoque"
                  descriptionField="descricao"
                  optionsList={localTable}
                  loading={localLoading}
                  value={localFilter}
                  setValue={setLocalFilter}
                />
              </Grid>
              <Grid item xs={12}>
                <Chip label="LENTES" />
              </Grid>
              <Grid item lg={5} md={3} sm={6} xs={4}>
                <TextFieldErp
                  id="codigo"
                  label="Código"
                  value={produtoLenteCodigo}
                  setValue={setProdutoLenteCodigo}
                />
              </Grid>
              <Grid item lg={6} md={3} sm={6} xs={5}>
                <SelectErp
                  id="descricao"
                  label="Descrição"
                  descriptionField="descricao"
                  value={produtoLenteDescricaoSelected}
                  setValue={setProdutoLenteDescricaoSelected}
                  optionsList={lenteTable}
                />
              </Grid>
              <Grid item flex={2}>
                <Tooltip title="Pesquisa Lente">
                  <IconButtonStyled>
                    <Search
                      onClick={() => {
                        setSearchLenteOpen(true);
                      }}
                    />
                  </IconButtonStyled>
                </Tooltip>
              </Grid>
              <Grid item xs={12}>
                <Chip label="ARO" />
              </Grid>
              <Grid item lg={5} md={3} sm={6} xs={4}>
                <TextFieldErp
                  id="codigoAro"
                  label="Código"
                  value={produtoAroCodigo}
                  setValue={setProdutoAroCodigo}
                />
              </Grid>
              <Grid item lg={6} md={3} sm={6} xs={5}>
                <SelectErp
                  id="descricaoAro"
                  label="Descrição"
                  descriptionField="descricao"
                  value={produtoAroDescricaoSelected}
                  setValue={setProdutoAroDescricaoSelected}
                  optionsList={aroTable}
                />
              </Grid>
              <Grid item flex={2}>
                <Tooltip title="Pesquisa Aro">
                  <IconButtonStyled>
                    <Search
                      onClick={() => {
                        setSearchAroOpen(true);
                      }}
                    />
                  </IconButtonStyled>
                </Tooltip>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </>
  );
};

export { AccordionPrescricaoProduto };
